import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DashboardWidget from './DashboardWidget';
import { query, where, getCountFromServer } from 'firebase/firestore';
import { useFirebaseService } from '../../data/FirebaseService';

const DashboardPage: React.FC = () => {
    const firebaseService = useFirebaseService();
    const [activeMessageCount, setActiveMessageCount] = useState<number | undefined>(undefined);
    const [messageCount, setMessageCount] = useState<number | undefined>(undefined);

    useEffect(() => {
        if (firebaseService) {
            const fetchActiveMessagesCount = async () => {

                const collection = await firebaseService.getCollection(`messages`);
                const q = query(collection,
                    where('isActive', '==', true),
                    where('endDate', '>', new Date()),
                );

                const snapshot = await getCountFromServer(q); // Get the count for the query
                setActiveMessageCount(snapshot.data().count); // Get the count from the snapshot
            };

            const fetchMessagesCount = async () => {

                const collection = await firebaseService.getCollection(`messages`);
                const q = query(collection,
                    where('createdDate', '>', new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)),
                );

                const snapshot = await getCountFromServer(q); // Get the count for the query
                setMessageCount(snapshot.data().count); // Get the count from the snapshot
            };

            fetchActiveMessagesCount();
            fetchMessagesCount();
        }
    }, [firebaseService]);

    return (
        <div>
            <Typography variant="h5" component="h2" className='page-title'>Dashboard</Typography>
            <DashboardWidget title="Active Messages" count={activeMessageCount} description="Total number of active messages" link="/messages?filter=active" />
            <DashboardWidget title="Messages Last 30 days" count={messageCount} description="Total number of messages sent in the last 30 days" link="/messages?filter=recent" />
        </div>
    );
};

export default DashboardPage;